import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcDate',
})
export class UtcDatePipe implements PipeTransform {
  /**
   * Marks a BE UTC date string as UTC by appending 'Z' when missing, so DatePipe shows it in local time.
   * @returns {string | null} The date string ending with a single 'Z', null when missing
   */
  transform(value: string | null | undefined): string | null {
    if (!value) return null;
    return value.endsWith('Z') ? value : value + 'Z';
  }
}
